import loadScript from '../load-script/load-script';
import loadStyle from '../load-style/load-style';
import { FULL_PAGE } from '../../../app/constants';

export default function loadDependencies(config, options) {
	const { uiCdnUrl, cdnUrl } = config;
	const { renderer, flowId = '' } = options || {};
	const fullPageContext = renderer === 'custom' && flowId.includes(FULL_PAGE);

	// Only needs the follow core ui assets in order to bootstrap full-page merge
	const commonResources = [
		loadScript(`${uiCdnUrl}/js/autogrow.js`, false, true),
		loadScript(`${uiCdnUrl}/js/date-validator.js`, false, true),
		loadScript(`${cdnUrl}/ui-static/lib/glue/1.2.0/glue-bundle.js`, false, true)
	];

	if (!fullPageContext) {
		commonResources.push([
			loadStyle(`${uiCdnUrl}/css/switch.css`),
			loadScript(`${uiCdnUrl}/js/switch.js`, false, true),
			loadScript(`${window.location.origin}/sharing/share.js`, true, false) // defer loading since we haven't loaded our React client yet
		]);
	}
	return Promise.all([...commonResources]);
}
